import { useEffect, useState, useRef } from 'react'
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline'
import ButtonComponent from 'components/common/ButtonComponent'
import 'styles/PackingDataEdit.css'
import { parseDate } from 'utils'
import { makeRequest } from 'services/request.service'
import { useAuth } from 'auth/AuthContext'
import { DateTime } from 'luxon'

export default function PackingDataEdit () {
  const { user } = useAuth()
  const hasFetched = useRef(false)
  const currentFilterDate = useRef(null)
  const [state, setState] = useState({
    packingData: [],
    currentDate: parseDate(new Date()),
    filterDate: DateTime.now().setZone('America/Mexico_City').toFormat('yyyy-MM-dd'),
    searchTerm: '',
    refresh: 0
  })

  const { packingData, currentDate, searchTerm, refresh } = state

  const getPackingData = async () => {
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/data-edit/packing-data/${user.farmId}?filterDate=${new Date(state.filterDate).toISOString()}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        }
      })

      setState({ ...state, packingData: response.data })
    } catch (error) {
      console.error('Error:', error)
    }
  }

  useEffect(() => {
    if (hasFetched.current && currentFilterDate.current === state.filterDate) return
    hasFetched.current = true
    currentFilterDate.current = state.filterDate
    getPackingData()
  }, [refresh, searchTerm, state.filterDate])

  const filteredPackingData = packingData.filter(item => {
    if (!searchTerm) return true
    return (
      item.workerName?.toLowerCase().includes(searchTerm) ||
      item.containerName?.toLowerCase().includes(searchTerm) ||
      item.stickerType?.toLowerCase().includes(searchTerm) ||
      item.containerMaterial?.toLowerCase().includes(searchTerm)
    )
  })

  return (
    <div className='p-6 bg-white shadow-md border border-gray-300 border-t-0'>
      <div className='section-header'>
        <div className='header-left'>
          <div className='date-filter'>
            <span>Today ({currentDate})</span>
          </div>
        </div>

        <div className='flex items-center gap-4 mb-6'>
          <ButtonComponent className='flex items-center gap-2'>
            <DocumentArrowDownIcon className='w-5 h-5' />
            <span>Export as Excel</span>
          </ButtonComponent>
          <ButtonComponent className='flex items-center gap-2'>
            <DocumentArrowDownIcon className='w-5 h-5' />
            <span>Export as PDF</span>
          </ButtonComponent>
        </div>
      </div>

      <div className='search-container'>
        <input
          type='text'
          placeholder='Search'
          value={state.searchTerm}
          onChange={(e) => setState(s => ({ ...s, searchTerm: e.target.value.toLowerCase() }))}
          className='w-48 mt-1 p-2 border rounded-md shadow-sm'
          data-align='left'
        />
        <input
          type='date'
          value={state.filterDate}
          onChange={e => setState(s => ({ ...s, filterDate: e.target.value }))}
          className='w-40 mt-2 mb-2 p-2 border rounded-md shadow-sm'
          data-align='left'
        />
      </div>

      <div className='data-table'>
        <table>
          <thead>
            <tr>
              <th><input type='checkbox' /></th>
              <th>Sticker ID</th>
              <th>Sticker Type</th>
              <th>Worker Name</th>
              <th>Date</th>
              <th>Container Name</th>
              <th>Container Material</th>
              <th>Gross Weight</th>
            </tr>
          </thead>
          <tbody>
            {filteredPackingData.map((item, index) => (
              <tr key={item.packingDataId || index}>
                <td><input type='checkbox' /></td>
                <td>{item.stickerId}</td>
                <td>{item.stickerType}</td>
                <td>{item.workerName}</td>
                <td>{parseDate(item.date)}</td>
                <td>{item.containerName}</td>
                <td>{item.containerMaterial}</td>
                <td>{item.grossWeight}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
